import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useAuthenticatedSemaphore} from './hooks/use-authenticated-semaphore'
import useTypedSelector from './hooks/use-typed-selector'
import {logInStatusSelector} from './store/state/session-data/selectors'
import {loggingOut} from './store/state/session-data/action-creators'
import {LoginStatus} from './store/state/session-data/state'
import {AuthenticatedRoutes} from './root/authenticated-routes'
import {UnauthenticatedRoutes} from './root/unauthenticated-routes'

function App(): JSX.Element {
    const dispatch = useDispatch()
    const loginStatus = useTypedSelector(logInStatusSelector)
    const {authenticationSemaphoreStatus} = useAuthenticatedSemaphore()

    useEffect(() => {
        if (authenticationSemaphoreStatus) {
            // Do nothing for now
        } else {
            if (
                loginStatus === null ||
                loginStatus === undefined ||
                loginStatus === LoginStatus.LOGGED_IN
            ) {
                dispatch(loggingOut())
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticationSemaphoreStatus, dispatch, loginStatus])

    return loginStatus === LoginStatus.LOGGED_IN ? (
        <AuthenticatedRoutes />
    ) : (
        <UnauthenticatedRoutes />
    )
}

export default App
